import React from 'react';
import {ShadowmapLogo} from './Icons';

const RootPage: React.FC = () => (
	<div className="page-center root-page">
		<div className="root-card">
			<ShadowmapLogo className="root-logo"/>
			<div className="root-links">
				<a href="/docs" className="root-link">Docs</a>
				<a href="/explorer" className="root-link">Explorer</a>
			</div>
		</div>
	</div>
);

export default RootPage;
